
import i18n from "../../../../i18n";
const IncidentID = i18n.t('manageAutomation.IncidentID');
const AssignedTo = i18n.t('manageAutomation.AssignedTo');
const IncidentStatus = i18n.t('manageAutomation.IncidentStatus');
const Priority = i18n.t('manageAutomation.Priority');
const ManagedEntity = i18n.t('manageAutomation.ManagedEntity');
const Client = i18n.t('manageAutomation.Client');
const ApplicationComponent = i18n.t('manageAutomation.ApplicationComponent');
const ConfigItem = i18n.t('manageAutomation.ConfigItem');
const ImplementationType = i18n.t('manageAutomation.ImplementationType');
const ImplementationStatus = i18n.t('manageAutomation.ImplementationStatus');
const Description = i18n.t('manageAutomation.Description');
const Category = i18n.t('manageAutomation.Category');
const ReleaseDate = i18n.t('manageAutomation.ReleaseDate');
const Version = i18n.t('manageAutomation.Version');
const SoftwareComponent = i18n.t('manageAutomation.SoftwareComponent');
const KernelNote = i18n.t('manageAutomation.KernelNote');
const SPRelevance = i18n.t('manageAutomation.SPRelevance');

const SysId = i18n.t('manageAutomation.SysId');

const SYSTEM_RECOMMENDATION_HEADERS = [
    {
        key: 'incidentId',
        header: IncidentID,
        hidden: false,
        optional: false
    },
    {
        key: 'assigned_to',
        header: AssignedTo,
        hidden: true,
        optional: true
    },
    {
        key: 'incidentStatus',
        header: IncidentStatus,
        hidden: false,
        optional: false
    },
    {
        key: 'priority',
        header: Priority,
        hidden: false,
        optional: false
    },
    {
        key: 'entity',
        header: ManagedEntity,
        hidden: false,
        optional: false
    },
    {
        key: 'application_component',
        header: ApplicationComponent,
        hidden: false,
        optional: false
    },
    // {
    //     key: 'description',
    //     header: Description,
    //     hidden: false,
    //     optional: false
    // },
    {
        key: 'config_item',
        header: ConfigItem,
        hidden: false,
        optional: false
    },
    {
        key: 'implementation_type',
        header: ImplementationType,
        hidden: false,
        optional: false
    },
    {
        key: 'implementation_status',
        header: ImplementationStatus,
        hidden: false,
        optional: false
    },
    {
        key: 'client',
        header: Client,
        hidden: true,
        optional: true
    },
    {
        key: 'category',
        header: Category,
        hidden: true,
        optional: true
    },
    {
        key: 'release_date',
        header: ReleaseDate,
        hidden: true,
        optional: true
    },
    {
        key: 'version',
        header: Version,
        hidden: true,
        optional: true
    },
    {
        key: 'software_component',
        header: SoftwareComponent,
        hidden: true,
        optional: true
    },
    {
        key: 'kernel_note',
        header: KernelNote,
        hidden: true,
        optional: true
    },
    {
        key: 'sp_relevance',
        header: SPRelevance,
        hidden: true,
        optional: true
    }
];
export default SYSTEM_RECOMMENDATION_HEADERS;